import React from 'react';

import PropTypes from 'prop-types';

import InfoCard from '~/components/InfoCard';
import LocaleMessage from '~/components/LocaleMessage';

import {
    estimateProductConsumptionMl,
    formatFluidVolume,
} from './cleaningReportConsumptionUtils';
import {
    formatEnergyKwh,
    summarizeCleaningConsumption,
} from './cleaningReportUtils';

export default function CleaningReportUtilityInfoCards({
    consumption,
    cardColor,
    robotDilutions,
    list,
}) {
    const fromAnalysis = !!(
        consumption && consumption.source === 'pudu_analysis'
    );
    const summary = summarizeCleaningConsumption(list);
    const waterMl = fromAnalysis
        ? Number(consumption.water_ml) || 0
        : summary.waterMl;
    const energyKwh = fromAnalysis
        ? Number(consumption.energy_kwh) || 0
        : summary.energyKwh;
    const hasData =
        fromAnalysis || summary.measuredWater > 0 || summary.measuredEnergy > 0;
    const isPartial = !!(
        consumption &&
        (consumption.warning === 'details_syncing' ||
            consumption.warning === 'details_pending')
    );
    const waterFmt = formatFluidVolume(waterMl);
    const waterTitle =
        hasData && (waterMl > 0 || fromAnalysis)
            ? `${waterFmt.value} ${waterFmt.unit}`
            : '—';
    const energyTitle =
        hasData && (energyKwh > 0 || fromAnalysis)
            ? formatEnergyKwh(energyKwh)
            : '—';
    const productMl = estimateProductConsumptionMl({
        consumption,
        robotDilutions,
        list,
    });
    const productFmt = formatFluidVolume(productMl || 0);
    const productTitle =
        productMl != null && (productMl > 0 || hasData)
            ? `${productFmt.value} ${productFmt.unit}`
            : '—';

    return (
        <>
            <div className="col-md-3 col-12 dash-card mb-3">
                <InfoCard
                    data={{
                        title: waterTitle,
                        subTitle: (
                            <>
                                <LocaleMessage msg="page.robots.cleaning_report.card_water" />
                                {isPartial ? (
                                    <>
                                        {' · '}
                                        <LocaleMessage msg="page.robots.cleaning_report.detail_sync.partial" />
                                    </>
                                ) : null}
                            </>
                        ),
                    }}
                    color={cardColor}
                    icon="invert-colors"
                />
            </div>
            <div className="col-md-3 col-12 dash-card mb-3">
                <InfoCard
                    data={{
                        title: energyTitle,
                        subTitle: (
                            <>
                                <LocaleMessage msg="page.robots.cleaning_report.card_energy" />
                                {isPartial ? (
                                    <>
                                        {' · '}
                                        <LocaleMessage msg="page.robots.cleaning_report.detail_sync.partial" />
                                    </>
                                ) : null}
                            </>
                        ),
                    }}
                    color={cardColor}
                    icon="flash"
                />
            </div>
            <div className="col-md-3 col-12 dash-card mb-3">
                <InfoCard
                    data={{
                        title: productTitle,
                        subTitle: (
                            <LocaleMessage msg="page.robots.cleaning_report.card_product" />
                        ),
                    }}
                    color={cardColor}
                    icon="collection-item"
                />
            </div>
        </>
    );
}

CleaningReportUtilityInfoCards.propTypes = {
    consumption: PropTypes.shape({
        source: PropTypes.string,
        water_ml: PropTypes.number,
        energy_kwh: PropTypes.number,
        by_robot: PropTypes.arrayOf(
            PropTypes.shape({
                sn: PropTypes.string,
                water_ml: PropTypes.number,
            })
        ),
    }),
    cardColor: PropTypes.string,
    robotDilutions: PropTypes.arrayOf(
        PropTypes.shape({
            robot_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            sn: PropTypes.string,
            dilution_ml_per_l: PropTypes.number,
        })
    ),
    list: PropTypes.arrayOf(PropTypes.shape({})),
};

CleaningReportUtilityInfoCards.defaultProps = {
    consumption: null,
    cardColor: '#3f51b5',
    robotDilutions: [],
    list: [],
};
